module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supervisor-stats"
  }, [_c('div', {
    staticClass: "statistic-container"
  }, [_c('div', {
    staticClass: "statistic-block"
  }, [_c('div', {
    staticClass: "statistic-head"
  }, [_vm._v("Всего анкет")]), _vm._v(" "), _c('div', {
    staticClass: "statistic-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        Сегодня\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm.statistics.questionnaires_day || '-') + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "statistic-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        За неделю\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm.statistics.questionnaires_week || '-') + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "statistic-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        За месяц\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm.statistics.questionnaires_month || '-') + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "statistic-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        За год\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm.statistics.questionnaires_year || '-') + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "statistic-container"
  }, [_c('div', {
    staticClass: "statistic-block"
  }, [_c('div', {
    staticClass: "statistic-head"
  }, [_vm._v("Среднее количество осмотров")]), _vm._v(" "), _c('div', {
    staticClass: "statistic-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        За день\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm.statistics.inspections_day || '-') + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "statistic-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        За неделю\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm.statistics.inspections_week || '-') + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "statistic-container"
  }, [_c('div', {
    staticClass: "statistic-block"
  }, [_c('div', {
    staticClass: "statistic-head"
  }, [_vm._v("\n                Среднее время осмотра\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "statistic-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        Минуты\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm.statistics.inspection_average || '-') + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-016c65a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-016c65a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/StatisticSupervisor.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-016c65a6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/StatisticSupervisor.vue
// module chunks = 0